
<template>

    <div class='app'>
        <!-- <center>
          Estamos atualizando o site
        </center> -->
        <!-- -->
        <mapbox></mapbox> 
        <cabecalho></cabecalho>
         
        <div id="conteudo-wraper" class="conteudo">
            <router-view ></router-view>
        </div> 

        <!-- <div v-if="open" id="banner" @click="open=false">

              <img src="/images/info.jpg"   />

        </div> -->

      

        
  </div>
</template>


<script>

    // require('./icons/index.js')


    export default {
      name: 'app',
      data () {
        return {
          open:true,
          mensagem:'ESUS GESTOR GEO',
          secoes:{
                camada:true,
                regiaoestudo:true,
                mapabase:true,
                filtrosaude:true,
          },
        }
      },


    created:function(){

         
            

    },

    
    computed:{
        
    },


    mounted:function(){
      
    },


      methods: {
        openToogle: function () {
                this.$store.commit('barraToogle')
        },
          
        contrasteToogle: function () {
            $('html').hasClass('contraste');
        },

        secaoVisivel:function(nome){
            return _.get(this.$store.state,`secoes.${nome}.exibir`, false)
        },


      },

    }
</script>






<style lang='stylus'>
  
  #banner{
position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 1199;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
          max-width: 70vw;
    max-height: 80vh;
    }
  }

    @import "css/variaveis";

      .app{
        position:absolute;
        top:0;
        // overflow: hidden;
        min-height: 100vh;

        // temporario
        width: 100%;
        height: 100%;

      }

      center {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color:white;
}

      
      

      html.mobileOpen{
        overflow:hidden !important;
        body{
          position:relative
        }
      }



</style>
